export enum CrawlerStatus {
    Pending = 'pending',
    Running = 'running',
    Success = 'success',
    Failure = 'failure',
    Aborted = 'aborted',
}
